import { render, staticRenderFns } from "./causeDetail.vue?vue&type=template&id=6f674db4&scoped=true"
import script from "./causeDetail.vue?vue&type=script&lang=js"
export * from "./causeDetail.vue?vue&type=script&lang=js"
import style0 from "./causeDetail.vue?vue&type=style&index=0&id=6f674db4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f674db4",
  null
  
)

export default component.exports